//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { Caption } from '@components/atoms/caption/Caption';
import ContentSourceType from '@models/ContentSourceType';
import { SocialNetwork } from '@models/SocialNetwork';
import {
  getHashtagHref,
  getUserHref,
} from '@uia/details/utils/socialNetworkUtils';
import { isDefined } from '@utils/filterPredicates';
import { parseSocialText } from '@utils/stringUtils';

export interface CaptionLinkProps {
  socialNetwork: SocialNetwork;
  text: string;
}

export const UIACaptionLink = ({ socialNetwork, text }: CaptionLinkProps) =>
  parseSocialText(text).map((item, index) => {
    let href: string | undefined = undefined;

    if (item.type === ContentSourceType.HASHTAG) {
      // Remove the leading # character from the username.
      const hashtag = item.value.replace('#', '');
      href = getHashtagHref(true, socialNetwork, hashtag);
    }

    if (item.type === ContentSourceType.LINK) {
      href = item.value;
    }

    if (item.type === ContentSourceType.MENTION) {
      // Remove the leading @ character from the username.
      const username = item.value.replace('@', '');
      href = getUserHref(true, socialNetwork, username);
    }

    if (isDefined(href)) {
      return (
        <Caption.CaptionLink
          key={`${item.value}-${index}`}
          href={href}
          text={item.value}
        />
      );
    } else {
      return <span key={`${item.value}-${index}`}>{item.value}</span>;
    }
  });
